// EVERY UPDATE, ADD NEW SEMESTERS TO LIST AND CHANGE DEFAULT SEMESTER
// if website takes too long to load in future because there are too many
//   past years of data, can remove / archive data folders in frontend
const SEMESTERS = [
  'spring2022',
  'fall2022',
  'spring2023',
  'fall2023',
  'spring2024',
  'fall2024',
  'spring2025',
  'fall2025',
  'spring2026',
  'fall2026',
  'spring2027',
];
const DEFAULT_SEMESTER = 'fall2026';

export { SEMESTERS, DEFAULT_SEMESTER };
